// const mainCollection = document.querySelector("[js-hb-main-collection]");
// if(mainCollection) {
//     const collectionCards = mainCollection.querySelectorAll("[js-collection-card]");

//     observeGridChanges();
           
//     function observeGridChanges() {
//         const productGrid = mainCollection.querySelector("[js-product-grid]");
    
//         if (!productGrid) return;
    
//         const observer = new MutationObserver((mutationsList) => {
//             mutationsList.forEach((mutation, index) => {
//                 if (index === mutationsList.length - 1 && mutation.type === "childList" && (mutation.target.tagName === "COLOR-SWATCHES" || mutation.target.classList.contains("quick-add"))) {
//                     collectionCards.forEach( card => {
//                         const desktopPosition = parseInt(card.dataset.hbPositionDesk);
//                         const mobilePosition = parseInt(card.dataset.hbPositionMob);
    
//                         appendGridItem(card, desktopPosition, mobilePosition)
//                     })

//                     handleResponsiveLayoutSwitch()
//                 }
//             });
//         });
    
//         observer.observe(productGrid, { childList: true, subtree: true });
//     }
    
//     function appendGridItem(card, desktopPosition, mobilePosition) {
//         const targetProductItem = mainCollection.querySelector(`[js-product-grid] .grid__item:nth-child(${document.documentElement.clientWidth > 767 ? desktopPosition : mobilePosition})`);
    
//         if (targetProductItem) {
//             targetProductItem.insertAdjacentHTML("beforebegin", card.innerHTML);
//         }
//     }
// }

class collectionGridItem extends HTMLElement {
    constructor() {
        super();

        this.mainCollection = document.querySelector("[js-hb-main-collection]");
        this.desktopPosition = parseInt(this.dataset.hbPositionDesk);
        this.mobilePosition = parseInt(this.dataset.hbPositionMob);

        this.init();

    };

    init() {
        this.appendGridItem();
    };

    appendGridItem() {
        const targetProductItem = this.mainCollection.querySelector(`[js-product-grid] .grid__item:nth-child(${document.documentElement.clientWidth > 767 ? this.desktopPosition : this.mobilePosition})`);
        
        if(targetProductItem) {
            targetProductItem.insertAdjacentHTML("beforebegin",this.innerHTML)
        }
    };
}
  
customElements.define('collection-grid-item', collectionGridItem);
  

